module.exports = __webpack_public_path__ + "static/media/loginimg.7111e964.png";